const imports = {
  mappingFields: 'Mapeo de campos',
  fieldsInDB: 'Campos en la base de datos',
  csvFields: 'Campo CSV',
  selectTheField: 'Seleccione el campo',
  csvFile: 'Archivo CSV',
  typeOfImport: 'Tipo de importación',
  selectTypeOfReports: 'Seleccione el tipo de informes',
  default: 'Valor predeterminado',
  uploadedSuccessfuly: '¡Cargado correctamente!',
  downloadExample: 'Descargar ejemplo',
  noCollection: 'No hay colección con este nombre',
  uploadMessage: 'SOLICITAR: {{num}} elementos. Esto puede llevar hasta 1 segundo por elemento.',
};

export default imports;
